var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home"},[(!_vm.emailSent)?_c('div',[_c('h5',[_vm._v(" "+_vm._s(_vm.$t("sending..."))+" ")]),_c('img',{attrs:{"src":"img/loading.svg"}})]):_c('div',[_c('img',{attrs:{"src":"img/sent.svg","width":"130px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }